import { normalizeTutorialLanguage } from "./language";

const text = (en, fa) => ({ en, fa });
const step = (titleEn, titleFa, bodyEn, bodyFa, icon) => ({
  title: text(titleEn, titleFa),
  body: text(bodyEn, bodyFa),
  icon,
});

export const MAIN_TUTORIALS = {
  laser_shot: {
    version: 2,
    steps: [
      step("Point your phone at the game screen", "ابتدا گوشی را به سمت صفحه بازی نشانه بگیرید", "◎"),
	  step("Touch the mobile screen and hold", "سپس صفحه موبایل را لمس کرده و نگه دارید", "✦"),
      step("Move your phone to aim", "حال گوشی خود را حرکت داده و نشانه گیری کنید", "Move your phone to place your laser over a target.", "گوشی را حرکت دهید تا لیزر شما روی هدف قرار بگیرد.", "◎"),
      step("Release to fire", "لمس را رها کنید تا شلیک کنید", "✦"),
      step("Distant targets score more", "هدف دورتر امتیاز بیشتری دارد", "Far targets are worth the most points. The highest total wins.", "هدف‌های دورتر بیشترین امتیاز را دارند. بیشترین مجموع برنده است.", "★"),
    ],
  },
  carball: {
    version: 3,
    steps: [
      step("Point where you want to drive", "جهت حرکت را مشخص کنید", "The joystick direction tells the car where to steer. Moving farther from the center adds more throttle.", "جهت جوی‌استیک مسیر هدایت ماشین را مشخص می‌کند. هرچه انگشت را از مرکز دورتر ببرید، شتاب بیشتر می‌شود.", "↗"),
      step("Hold Reverse to back up", "برای عقب رفتن دکمه معکوس را نگه دارید", "In red Reverse mode, the target shows where the rear of your car will travel.", "در حالت قرمز معکوس، نشانگر جهت حرکت عقب ماشین را نمایش می‌دهد.", "R"),
      step("Push the ball into the opposing goal", "توپ را وارد دروازه حریف کنید", "Work with your team and drive the ball into the other goal.", "با تیم خود همکاری کنید و توپ را وارد دروازه حریف کنید.", "●"),
      step("Goals decide the winner", "گل‌ها برنده را مشخص می‌کنند", "First to 5 goals wins!", "اولین تیمی که 5 گل بزند برنده است.", "⚑"),
    ],
  },
  car_race: {
    version: 3,
    steps: [
      step("Point where you want to drive", "جهت حرکت را مشخص کنید", "The joystick direction tells the car where to steer. Moving farther from the center adds more throttle.", "جهت جوی‌استیک مسیر هدایت ماشین را مشخص می‌کند. هرچه انگشت را از مرکز دورتر ببرید، شتاب بیشتر می‌شود.", "↗"),
      step("Hold Reverse when you need to back out", "برای عقب رفتن دکمه معکوس را نگه دارید", "The red target shows where the rear of your car will travel.", "نشانگر قرمز جهت حرکت عقب ماشین را نمایش می‌دهد.", "R"),
      step("Follow the course", "مسیر را دنبال کنید", "Pass the checkpoints in order and stay on the track.", "ایستگاه‌های مسیر را به‌ترتیب رد کنید و در پیست بمانید.", "◇"),
      step("Finish first", "اول به خط پایان برسید", "Complete the required laps quickly. Better finishing position earns a better score.", "دورها را سریع تر تمام کنید. رتبه بهتر، امتیاز بیشتری می‌دهد.", "⚑"),
    ],
  },
  ring_guard: {
    version: 2,
    steps: [
      step("Guard the Ring", "در نوبت خود از دایره دفاع کنید", "Drag the phone control to move your guard around the ring.", "با گوشی محافظ خود را دور حلقه حرکت دهید.", "◯"),
      step("Survive and don't get scored on", "دوام بیاورید و گل نخورید", "Protect the ring for as long as possible. Last player standing wins.", "نفر آخر که بیشتر دوام بیاورد برنده است.", "♥"),
    ],
  },
  curling: {
    version: 2,
    steps: [
      step("Drag to aim your stone toward the target rings.", "برای نشانه‌گیری سنگ به سمت حلقه‌های هدف (مرکز زمین) بِکِشید.", "➜"),
      step("Use a faster pull for more speed, release to slide.", "برای سرعت بیشتر، سریعتر بکشید و رها کنید.", "●"),
      step("Finish closest to win!", "نزدیکترین سنگ به مرکز برنده است", "Stones closer to the center score higher.", "سنگ‌های نزدیک‌تر به مرکز، امتیاز بالاتری می‌گیرند.", "◎"),
    ],
  },
  foosball: {
    version: 2,
    steps: [
      step("Touch a rod and move vertically to move it!", "میله را لمس کرده و با حرکت باعمودی، آن را حرکت دهید", "↕"),
      step("To rotate the rod, swipe horizontally.", "برای چرخاندن میله، انگشت خود را افقی حرکت دهید.", "↻"),
      step("Score in the other goal", "به دروازه حریف گل بزنید", "First to 10 goals wins! With 4 minutes time limit.", "اولین تیمی که 10 گل بزند برنده است. با محدودیت زمانی 4 دقیقه", "⚽"),
    ],
  },
  football: {
    version: 2,
    steps: [
      step("Move your piece", "مهره خود را حرکت دهید", "Use the movement control to chase the ball and support your team.", "با کنترل حرکت توپ را دنبال کنید و به تیم کمک کنید.", "↗"),
      step("Shoot!", "شوت کنید!", "Hold the shoot button and release near the ball to apply force.", "دکمه شوت را نگه دارید و در نزدیکی توپ رها کنید تا به توپ نیرو وارد کنید", "⚽"),
      step("First to 5 goals wins!", "اولین تیمی که 5 گل بزند برنده است", "The match ends at the score limit or when time expires. The team with more goals wins.", "بازی با رسیدن به حد امتیاز یا پایان زمان تمام می‌شود. تیم با گل بیشتر برنده است.", "⚑"),
    ],
  },
  eggs_fight: {
    version: 2,
    steps: [
      step("Shoot or Jump", "پرش یا شلیک", "Select Jump or Shoot, then aim and determine the strength and release", "شلیک یا پرش را انتخاب کنید سپس با جوی استیک نشانه گرفته و قدرت را نیز مشخص کنید .", "↗"),
      step("Cancel Your Move", "لغو حرکت شما", "Release the joysitck at the center to cancel", "جوی استیک را در مرکز رها کنید تا حرکت شما لغو شود.", "✦"),
      step("Last team standing wins!", "آخرین تیم باقی‌مانده برنده است", "★"),
    ],
  },
  headball: {
    version: 2,
    steps: [
      step("Move under the ball", "زیر توپ حرکت کنید", "Slide left and right to get into the best position.", "به چپ و راست حرکت کنید تا در بهترین موقعیت قرار بگیرید.", "↔"),
      step("Jump for the header", "برای ضربه سر بپرید", "Time your jump to send the ball over the opponent.", "پرش را زمان‌بندی کنید تا توپ را در زمین حریف بزنید.", "↑"),
      step("Score goals", "گل بزنید", "A ball landing in the opposing side adds one point. Reach 15 goals first in 4 minutes.", "افتادن توپ در زمین حریف امتیاز دارد. 4 دقیقه فرصت دارید تا به 15 گل برسید.", "⚽"),
    ],
  },
  ice_billiards: {
    version: 2,
    steps: [
      step("Slide your pallet", "مهره خود را سُر دهید", "In your turn, slide your pallet with your finger", "در نوبت خود با حرکت انگشت، مهره خود را سرُ دهید", "◎"),
      step("Release to slide", "برای حرکت (سُر دادن) رها کنید", "The release direction and speed determine the shot power.", "جهت و سرعت رها کردن، قدرت ضربه را مشخص می‌کند.", "➜"),
      step("Pocket black stones", "سنگ‌های سیاه را وارد حفره کنید", "Pocket the black stones to score points.", "سنگ‌های سیاه را وارد حفره کنید تا امتیاز کسب کنید.", "★"),
      step("Don't pocket white stones!", "سنگ‌های سفید را وارد حفره نکنید", "Avoid pocketing the white stones, as they penalties.", "سنگ‌های سفید را وارد حفره نکنید، زیرا امتیاز منفی دارند.", "★"),
    ],
  },
  marble_sling: {
    version: 2,
    steps: [
      step("Load your marble", "تیله را آماده کنید", "Touch on the marble to load it.", "بر روی تیله لمس کنید تا لود شود.", "●"),
      step("Pull, aim, release", "بکشید، نشانه بگیرید، رها کنید", "Aim at the holes to move your marbels out of your zone.", "به سمت سوراخ ها نشانه بگیرید تا تیله هایتان را به بیرون بفرستید.", "➜"),
      step("Send marbels to other players zones", "تیله‌ها را به مناطق بازیکنان دیگر بفرستید", "The player with less marbels in their zone wins.", "بازیکن با تیله های کمتر در منطقه خود، برنده است.", "◎"),
    ],
  },
  math_race: {
    version: 2,
    steps: [
      step("configure the run", "تنظیمات بازی را انجام دهید", "Choose the level, number of questions and the operations used in the questions.", "سطح سوالات، تعداد سوالات و همچنین عملیات ریاضی که در سوالات به کار رود را انتخاب کنید.", "⚙"),
      step("Read the question from the main screen", "سوال را از صفحه اصلی بخوانید", "A math question appears on the shared game screen.", "یک پرسش ریاضی روی صفحه مشترک بازی نمایش داده می‌شود.", "?"),
      step("Enter and send", "پاسخ را وارد و ارسال کنید", "Use the keypad and send your answer before the others.", "با صفحه‌کلید پاسخ را وارد کنید و زودتر ارسال کنید.", "123"),
      step("Correct answers advance", "پاسخ درست سوال بعدی را نمایش می دهد", "At the end, the player with the most correct answers wins.", "در انتها هر کس پاسخ درست بیشتری داده باشد برنده می شود", "⚑"),
    ],
  },
  pong3D: {
    version: 2,
    steps: [
      step("Block the ball with the paddle", "راکت را حرکت دهید و توپ را بلاک کنید", "The ball moves in 3d space. Don't let it pass you on your turn.", "توپ در فضای 3 بعدی حرکت می کند. اجازه ندهید در نوبت تان، از شما عبور کند.", "↔"),
      step("Whoever miss the ball loses", "هر کس گل بخورد می بازد", "Last one standing wins.", "نفر آخری که باقی بماند برنده است.", "★"),
    ],
  },
  running_race: {
    version: 2,
    steps: [
      step("Frame up to 4 runners on each phone", "همه دونده ها (تا 4 نفر روی هر موبایل) در تصویر باشند", "Place the phone securely so each player’s full body and ankles are visible.", "گوشی را ثابت بگذارید تا بدن کامل و مچ پای همه بازیکنان دیده شود.", "▣"),
      step("Run and jump in place", "درجا بدوید و بپرید", "Run in your assigned camera zone and jump when the course requires it.", "در ناحیه دوربین خود درجا بدوید و نزدیک مانع ها بپرید.", "↑"),
      step("Reach the finish first", "اول به پایان برسید", "Consistent detected steps move your racer. The first racer across the finish wins.", "قدم‌های تشخیص‌داده‌شده، مسابقه‌دهنده را حرکت می‌دهد. اولین نفر در خط پایان برنده است.", "⚑"),
    ],
  },
  shooter_royal: {
    version: 2,
    steps: [
      step("Move with one control", "با یک کنترل حرکت کنید", "Use the movement pad to find cover and a clear firing position.", "با جوی استیک، حرکت کنید و پناه بگیرید و موقعیت مناسب شلیک پیدا کنید.", "↗"),
      step("Aim and fire with the other", "با جوی استیک دیگر نشانه بگیرید و شلیک کنید", "Use the aim pad to point at opponents and then push the joystick to the end in that direction to shoot.", "با جوی استیک دیگر، حریف را هدف بگیرید و برای شلیک جوی استیک را تا انتها در همان جهت ببرید.", "◎"),
      step("Outlast the arena", "در میدان دوام بیاورید", "Last team standing wins!", "تیم آخری که زنده بماند برنده است.", "★"),
    ],
  },
  table_hockey: {
    version: 2,
    steps: [
      step("Drag your paddle", "مهره خود را حرکت دهید", "Move inside your allowed area.", "در محدوده مجاز (زمین خود) حرکت کنید.", "↔"),
      step("Strike toward an opponent", "به سمت حریف ضربه بزنید", "Use quick controlled movements to send the puck into another goal.", "با حرکت سریع و کنترل‌شده توپ را وارد دروازه دیگری کنید.", "●"),
      step("Goals change your score", "بیشترین گل برنده است", "Scoring adds a point; conceding can subtract one. Reach the winning score first.", "گل زدن یک امتیاز اضافه و گل خوردن ممکن است یک امتیاز کم کند. زودتر به امتیاز نهایی برسید.", "★"),
    ],
  },
  uno: {
    version: 1,
    steps: [
      step("Match the center card", "کارت وسط را تطبیق دهید", "Play a card with the same color, number, or symbol as the center card.", "کارتی با رنگ، عدد یا نشانه مشابه کارت وسط بازی کنید.", "▣"),
      step("Draw when needed", "در صورت نیاز کارت بکشید", "If you cannot play, draw a card and follow the available action on your phone.", "اگر کارت قابل بازی ندارید، کارت بکشید و گزینه نمایش‌داده‌شده روی گوشی را انجام دهید.", "+1"),
      step("Empty your hand", "دست خود را خالی کنید", "Use wild cards carefully. The first player with no cards remaining wins.", "کارت‌های آزاد را هوشمندانه استفاده کنید. اولین بازیکن بدون کارت برنده است.", "★"),
    ],
  },
  snake: {
    version: 2,
    steps: [
      step("Steer continuously", "پیوسته هدایت کنید", "Keep your finger on the screen and swipe to change the snake's direction. Don't let your finger lift off the screen.", "انگشت خود را روی صفحه نگه دارید و با حرکت انگشت، جهت حرکت مار را تعیین کنید. انگشت خود را برندارید.", "↻"),
      step("Collect and grow", "جمع کنید و رشد کنید", "Pick up food to increase your length and improve your score.", "غذاها را جمع کنید تا طول و امتیاز شما بیشتر شود.", "●"),
      step("Avoid every collision", "از برخورد دوری کنید", "Walls, obstacles, and other snakes can eliminate you. Survive with the strongest score.", "دیوار، مانع و مارهای دیگر می‌توانند شما را حذف کنند. با بهترین امتیاز دوام بیاورید.", "⚠"),
    ],
  },
};

export function getMainTutorial(gameKey, language) {
  const tutorial = MAIN_TUTORIALS[gameKey];
  if (!tutorial?.steps?.length) return null;
  const lang = normalizeTutorialLanguage(language);
  return {
    gameKey,
    version: tutorial.version,
    language: lang,
    direction: lang === "fa" ? "rtl" : "ltr",
    steps: tutorial.steps.map((item) => ({
      title: item.title[lang] || item.title.en,
      body: item.body[lang] || item.body.en,
      icon: item.icon,
    })),
  };
}
